const cellSizeEditor = 40;
export default cellSizeEditor;